module.exports = __webpack_public_path__ + "img/Camelopardalis.888681ca.png";